<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>产销统计</span>
        </div>

        <el-form ref="queryForm" :model="queryParams" :inline="true">
          <el-form-item label="用户类型" prop="level">
            <el-select
              v-model.number="queryParams.level"
              placeholder="请选择类型"
              clearable
              size="small"
              @keyup.enter.native="handleQuery"
            >
              <el-option
                v-for="(item, index) in userType"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="奖励类型" prop="type">
            <el-select
              v-model.number="queryParams.type"
              placeholder="请选择类型"
              clearable
              size="small"
              @keyup.enter.native="handleQuery"
            >
              <el-option
                v-for="(item, index) in rewardType"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="开始日期" prop="startDate">
            <el-date-picker
              v-model="queryParams.startDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item label="结束日期" prop="endDate">
            <el-date-picker
              v-model="queryParams.endDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">查询</el-button>
          </el-form-item>
        </el-form>

        <el-table
          v-loading="loading"
          :data="tableData"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="date"
            label="日期"
            align="center"
            width="130px"
          />
          <el-table-column align="center" label="累计结余">
            <el-table-column
              prop="stock_spin"
              align="center"
              label="总数"
              :formatter="numFormatter2"
              width="200"
            />
            <el-table-column
              prop="stock_spin_avg"
              align="center"
              label="人均"
              :formatter="numFormatter2"
              width="200"
            />
          </el-table-column>
          <el-table-column align="center" label="累计产出">
            <el-table-column
              prop="grant_spin"
              align="center"
              label="总数"
              width="200"
              :formatter="numFormatter2"
            />
            <el-table-column
              prop="grant_spin_avg"
              align="center"
              label="人均"
              width="200"
              :formatter="numFormatter2"
            />
          </el-table-column>
          <el-table-column align="center" label="累计消耗">
            <el-table-column
              prop="cost_spin"
              align="center"
              label="总数"
              width="200"
              :formatter="numFormatter2"
            />
            <el-table-column
              prop="cost_spin_avg"
              align="center"
              label="人均"
              width="200"
              :formatter="numFormatter2"
            />
          </el-table-column>

          <el-table-column align="center" label="收集活动产出">
            <el-table-column
              prop="collect_spin"
              align="center"
              label="总数"
              width="200"
              :formatter="numFormatter2"
            />
            <el-table-column
              prop="collect_spin_avg"
              align="center"
              label="人均"
              width="200"
              :formatter="numFormatter2"
            />
          </el-table-column>

          <el-table-column align="center" label="锦标赛产出">
            <el-table-column
              prop="rank_spin"
              align="center"
              label="总数"
              width="200"
              :formatter="numFormatter2"
            />
            <el-table-column
              prop="rank_spin_avg"
              align="center"
              label="人均"
              width="200"
              :formatter="numFormatter2"
            />
          </el-table-column>

          <el-table-column align="center" label="集齐卡组产出">
            <el-table-column
              prop="collect_card"
              align="center"
              label="总数"
              width="200"
              :formatter="numFormatter2"
            />
            <el-table-column
              prop="collect_card_avg"
              align="center"
              label="人均"
              width="200"
              :formatter="numFormatter2"
            />
          </el-table-column>

          <el-table-column align="center" label="连环礼包产出">
            <el-table-column
              prop="serial_pack"
              align="center"
              label="总数"
              width="200"
              :formatter="numFormatter2"
            />
            <el-table-column
              prop="serial_pack_avg"
              align="center"
              label="人均"
              width="200"
              :formatter="numFormatter2"
            />
          </el-table-column>
        </el-table>

        <!--        产销统计-->
        <el-row :gutter="12">
          <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">
            <OutputsStats ref="data" />
          </el-col>
          <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">
            <OutputsStats ref="data2" :legend="legend" :keys="keys" :title="'人均产出消耗'" />
          </el-col>
        </el-row>

      </el-card>

      <el-card v-if="echartStat.includes(queryParams.type)">
        <SpinsConsumeTotal ref="total" :typ="'+'" :title="'产出占比'" :rid="ridType" :reward="rewardType" />
      </el-card>

      <el-card v-if="echartStat.includes(queryParams.type)">
        <SpinsConsumeTotal ref="total1" :typ="'-'" :title="'消耗占比'" :rid="ridType" :reward="rewardType" />
      </el-card>

      <!--      <el-card>-->
      <!--        <SpinsConsumeAct ref="act" />-->
      <!--      </el-card>-->

      <!--      <grantStat />-->

    </template>
  </BasicLayout>
</template>

<script>
import { exportStatData, getSpinsConsume } from '@/api/statistics/user_remain'
import SpinsConsumeTotal from '@/views/config/spins-consume/compents/total.vue'
import { getRewardType } from '@/api/config/slot'
import { getRidTypeList } from '@/api/config/reward-record'
import { scientificFormat } from '@/utils'
import OutputsStats from '@/views/config/spins-consume/compents/outputs.vue'

export default {
  name: 'SpinsConsume',
  components: {
    OutputsStats,
    SpinsConsumeTotal
    // SpinsConsumeAct
  },
  data() {
    return {
      keys: ['stock_spin_avg', 'grant_spin_avg', 'cost_spin_avg', 'collect_spin_avg', 'rank_spin_avg', 'serial_pack_avg'],
      legend: ['人均结余', '人均产出', '人均消耗', '收集活动人均产出', '锦标赛人均产出', '莲华礼包人均产出'],
      userType: [{ label: '全部', value: 0 }, { label: '非付费用户', value: 1 }, { label: '付费用户', value: 2 }],
      echartStat: [14, 15, 22, 65, 69, 70],
      rewardType: [],
      rewardId: [14, 15, 65, 22],
      ridType: {},
      country: [],
      chartData: {},
      queryParams: {
        pageIndex: 1,
        pageSize: 10,
        startDate: '',
        endDate: '',
        country: '',
        type: 14,
        level: 0
      },
      loading: false,
      options: [],
      tableData: [],
      date: [],
      chart: {},
      option: {}
    }
  },
  created() {
    this.getRidTypeData()
    this.getRewardTypeData()
    this.getTables()
  },
  methods: {
    handleKeyUp() {
      this.onSubmit()
    },
    resetQuery() {
      this.resetForm('queryForm')
      this.handleQuery()
    },
    handleQuery() {
      if (this.queryParams.startDate === '') {
        this.msgError('请选择开始日期')
        return
      }

      if (this.queryParams.endDate === '') {
        this.msgError('请选择结束日期')
        return
      }

      this.getTables()
    },
    getTables() {
      getSpinsConsume(this.queryParams).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.data
          if (!this.tableData) {
            this.tableData = []
          }
          this.$refs.data.refresh(res.data.data)
          this.$refs.data2.refresh(res.data.data)
          this.$refs.total.refresh(res.data.data, res.data.rewardStat, res.data.dateArr, this.ridType)
          this.$refs.total1.refresh(res.data.data, res.data.rewardStat, res.data.dateArr, this.ridType)
          this.queryParams.startDate = res.data.req.startDate
          this.queryParams.endDate = res.data.req.endDate
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getRewardTypeData() {
      getRewardType().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            const id = parseInt(i)
            if (this.rewardId.includes(id)) {
              this.rewardType.push({ 'label': res.data[i], 'value': id })
            }
          }
        }
      })
    },
    getRidTypeData() {
      getRidTypeList().then(res => {
        if (res.code === 200) {
          this.ridType = res.data
          // for (const i in res.data) {
          //   this.ridType.push({ 'label': res.data[i], 'value': parseInt(i) })
          // }
        }
      })
    },
    exportData(typ) {
      exportStatData({ startDate: this.queryParams.startDate, endDate: this.queryParams.endDate, type: typ }).then(res => {
        if (res.code === 200) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    numFormatter2(col, row, val) {
      return scientificFormat(val)
    }
  }
}
</script>

<style scoped>
</style>
